import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { NavigationBar } from 'enable-ui';

import { COLOR_CONFIG } from 'constants/color';

import { useController } from '../core/controller';
import { MenuFooter } from './MenuFooter';
import { MenuHeader } from './MenuHeader';

//To-do-contribute design: Update these below attributes to dropdown items (reduce hoverable area)
const NavigationWrapper = styled.div`
  height: 100%;
  white-space: nowrap;
  .es-navbar-body {
    .group-title {
      padding: 16px 24px 6px 24px;
      width: 100%;
      height: 42px;

      p {
        font-size: 14px;
        line-height: 20px;
        font-weight: 600;
        color: ${COLOR_CONFIG['neutral-text']};
      }
    }
    overflow-x: hidden;
  }
  .active {
    background-color: #fd8a241a;
    color: #fd8a24 !important;
    svg path {
      /* fill: #fd8a24; */
      stroke: #fd8a24 !important;
    }
  }
  .nav-item {
    padding: 0 24px;
    height: 56px;
    font-size: 18px;
    line-height: 26px;
    font-weight: 500;
    border-radius: 0;
    margin: 0;
    color: #222222;
    div:first-child {
      margin-right: 16px;
    }
    svg {
      width: 24px;
      height: 24px;
      path {
        stroke: #808080;
      }
    }
  }
`;

export const SidebarMenu = ({ isShowMenu }: { isShowMenu: boolean }) => {
  const { menus, locationPathName, delay } = useController(isShowMenu);

  return (
    <React.Fragment>
      <NavigationWrapper>
        <NavigationBar
          header={<MenuHeader delay={delay} />}
          containerStyle={{
            background: `${COLOR_CONFIG.doctor}`,
          }}
          menuItems={menus}
          mode="vertical"
          width="100%"
          height="100%"
          locationPathName={locationPathName}
          footer={<MenuFooter delay={delay} />}
        />
      </NavigationWrapper>
    </React.Fragment>
  );
};
